import Vue from "vue";
import { startCase as _startCase } from "lodash";
import PARTIES from "Constants/campaign/civicactioncenter/parties";
import STATE from "Constants/campaign/civicactioncenter/state";

const { DEMOCRAT, REPUBLICAN, INDEPENDENT } = PARTIES;

function makeBreadcrumb({ name, party }) {
  if (!name) return "";
  if (!party) return name;

  if ([DEMOCRAT, REPUBLICAN, INDEPENDENT].includes(party)) {
    return `${name} (${party[0].toUpperCase()})`;
  }

  return `${name} (${_startCase(party)})`;
}

export default {
  namespaced: true,
  state: {
    [STATE.CANDIDATE_PREVIEWS]: {},
    [STATE.CANDIDATE_PROFILES]: {},
    [STATE.CURRENT_CANDIDATE_ID]: null,
    [STATE.ELECTED_OFFICIAL_PREVIEWS]: {},
    [STATE.ELECTED_OFFICIAL_PROFILES]: {},
    [STATE.CURRENT_OFFICIAL_ID]: null
  },
  mutations: {
    [STATE.CANDIDATE_PREVIEWS](state, candidate) {
      Vue.set(state[STATE.CANDIDATE_PREVIEWS], candidate.id, candidate);
    },
    [STATE.CANDIDATE_PROFILES](state, candidate) {
      Vue.set(state[STATE.CANDIDATE_PROFILES], candidate.id, candidate);
    },
    [STATE.ELECTED_OFFICIAL_PREVIEWS](state, official) {
      Vue.set(state[STATE.ELECTED_OFFICIAL_PREVIEWS], official.id, official);
    },
    [STATE.ELECTED_OFFICIAL_PROFILES](state, official) {
      Vue.set(state[STATE.ELECTED_OFFICIAL_PROFILES], official.id, official);
    },
    [STATE.CURRENT_CANDIDATE_ID](state, id) {
      state[STATE.CURRENT_CANDIDATE_ID] = id;
    },
    [STATE.CURRENT_OFFICIAL_ID](state, id) {
      state[STATE.CURRENT_OFFICIAL_ID] = id;
    }
  },
  actions: {
    [STATE.CANDIDATE_PREVIEWS]({ commit }, candidates) {
      candidates.forEach(candidate =>
        commit(STATE.CANDIDATE_PREVIEWS, candidate)
      );
    },
    [STATE.CANDIDATE_PROFILES]({ commit }, candidate) {
      commit(STATE.CANDIDATE_PROFILES, candidate);
    },
    [STATE.ELECTED_OFFICIAL_PREVIEWS]({ commit }, officials) {
      officials.forEach(official =>
        commit(STATE.ELECTED_OFFICIAL_PREVIEWS, official)
      );
    },
    [STATE.ELECTED_OFFICIAL_PROFILES]({ commit }, official) {
      commit(STATE.ELECTED_OFFICIAL_PROFILES, official);
    },
    [STATE.CURRENT_CANDIDATE_ID]({ commit }, id) {
      commit(STATE.CURRENT_CANDIDATE_ID, id);
    },
    [STATE.CURRENT_OFFICIAL_ID]({ commit }, id) {
      commit(STATE.CURRENT_OFFICIAL_ID, id);
    }
  },
  getters: {
    [STATE.CANDIDATE_PREVIEWS_ALL](state) {
      return Object.values(state[STATE.CANDIDATE_PREVIEWS]);
    },
    [STATE.CURRENT_CANDIDATE_DATA](state) {
      const currentId = state[STATE.CURRENT_CANDIDATE_ID];

      // Candidate profile data doesn't contain the race they're running for,
      // which we need for the Profile page title. Pull it from the preview if available.
      const profile = state[STATE.CANDIDATE_PROFILES][currentId];
      if (!profile) {
        return false;
      }

      const preview = state[STATE.CANDIDATE_PREVIEWS][currentId] || {};
      return {
        ...profile,
        race: preview.race || ""
      };
    },
    [STATE.CURRENT_CANDIDATE_BREADCRUMB](state, getters) {
      const candidate = getters[STATE.CURRENT_CANDIDATE_DATA];
      return makeBreadcrumb(candidate);
    },
    [STATE.ELECTED_OFFICIAL_PREVIEWS_ALL](state) {
      return Object.values(state[STATE.ELECTED_OFFICIAL_PREVIEWS]);
    },
    [STATE.CURRENT_OFFICIAL_DATA](state) {
      const currentId = state[STATE.CURRENT_OFFICIAL_ID];
      return state[STATE.ELECTED_OFFICIAL_PROFILES][currentId] || false;
    },
    [STATE.CURRENT_OFFICIAL_BREADCRUMB](state, getters) {
      const official = getters[STATE.CURRENT_OFFICIAL_DATA];
      return makeBreadcrumb(official);
    }
  }
};
